<template>
  <div class="container pb-3">
    <h1 class="mt-2">Mon compte</h1>
    <ValidationObserver ref="form" v-if="account.id">
      <div class="row mt-3 mt-lg-5 p-0">
        <div class="col-md-9">
          <ValidationProvider :rules="{required: true}" vid="first_name" name="Nom" v-slot="{ validate, errors }"
                              tag="div" class="w-100">
            <div class="form-group row">
              <label for="first_name" class="col-md-4 col-form-label">Nom</label>
              <div class="col-md-8">
                <input :class="{'is-invalid':!!errors[0]}" type="text" id="first_name" v-model="account.first_name" class="form-control"
                       name="first_name" required placeholder="Nom"/>
              </div>
              <span class=" text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider :rules="{required: true}" vid="last_name" name="Prenom" v-slot="{ validate, errors }"
                              tag="div" class="w-100">
            <div class="form-group row">
              <label for="last_name" class="col-md-4 col-form-label">Prenom</label>
              <div class="col-md-8">
                <input :class="{'is-invalid':!!errors[0]}" type="text" id="last_name" v-model="account.last_name" class="form-control" name="last_name"
                       required placeholder="Prenom"/>
              </div>
              <span class=" text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider :rules="{required: true}" vid="pseudo" name="Pseudo" v-slot="{ validate, errors }"
                              tag="div" class="w-100">
            <div class="form-group row">
              <label for="pseudo" class="col-md-4 col-form-label">Pseudo</label>
              <div class="col-md-8">
                <input :class="{'is-invalid':!!errors[0]}" type="text" id="pseudo" v-model="account.pseudo" class="form-control" name="pseudo" required
                       placeholder="Pseudo"/>
              </div>
              <span class=" text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="birth_date" name="Date" v-slot="{ validate, errors }" tag="div"
                              class="w-100 mt-4">
            <div class="form-group row">
              <label for="day" class="col-md-3 col-form-label">Date de naissance</label>
              <div class="col-md-8 offset-md-1 justify-content-between">
                <flat-pickr :class="{'is-invalid':!!errors[0]}" :config="{...configDate, ...{defaultDate: account.birth_date}}"
                            v-model="account.birth_date" id="day" placeholder="2012-12-12"
                            class="form-control bg-white" name="birth_date"/>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <div class="line bg-gray mb-4"></div>

          <ValidationProvider :rules="{required: true}" vid="gender" name="gender" v-slot="{ validate, errors }"
                              tag="div" class="w-100">
            <div class="form-group row">
              <label class="col-md-4 col-form-label">Sexe</label>
              <div class="col-md-8">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" name="gender" v-model="account.gender" type="radio"
                         id="gender-male" value="M" required>
                  <label class="form-check-label" for="gender-male">M</label>
                </div>
                <div class="form-check form-check-inline">
                  <input  class="form-check-input" name="gender" v-model="account.gender" type="radio"
                         id="gender-female" value="F" required>
                  <label class="form-check-label" for="gender-female">F</label>
                </div>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider :rules="{required: true}" vid="classroom_id" name="Classe / Niveau"
                              v-slot="{ validate, errors }" tag="div" class="w-100">
            <div class="form-group row">
              <label for="classroom_id" class="col-md-4 col-form-label">Classe</label>
              <div class="col-md-8 row justify-content-between mx-0">
                <select :class="{'is-invalid':!!errors[0]}" name="classroom_id" v-model="account.classroom_id" id="classroom_id"
                        class="form-control px-0">
                  <option :value="null" disabled selected>Select Classroom</option>
                  <option :value="classroom.id" class="title fz-16"
                          v-for="(classroom, indexcl) in classrooms" :key="indexcl">
                    {{ classroom.name }}
                  </option>
                </select>
              </div>
              <span class="col-md-12 text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider :rules="{required: true}" vid="school_name" name="Etablissement"
                              v-slot="{ validate, errors }" tag="div" class="w-100" v-if="school.default">
            <div class="form-group row">
              <label for="school_name" class="col-md-4 col-form-label">Etablissement</label>
              <div class="col-md-8">
                <input :class="{'is-invalid':!!errors[0]}" type="text" id="school_name" v-model="account.school_name" class="form-control"
                       name="school_name" required placeholder="Nom de l'etablissement"/>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <template v-else>
            <div class="form-group row">
              <label class="col-md-4 col-form-label">Etablissement</label>
              <div class="col-md-8">
                <input :class="{'is-invalid':!!errors[0]}" type="text" class="form-control" disabled v-model="school.name">
              </div>
            </div>
          </template>

          <div class="line bg-gray mb-4"></div>

          <ValidationProvider :rules="{required: true, min:4}" vid="email" name="Email"
                              v-slot="{ validate, errors }" tag="div" class="w-100">
            <div class="form-group row">
              <label for="email" class="col-md-4 col-form-label">Adresse Email</label>
              <div class="col-md-8">
                <input :class="{'is-invalid':!!errors[0]}" type="text" id="email" v-model="account.email" class="form-control" name="email" required
                       placeholder="email@email.com"/>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider :rules="{required: true}" vid="phone" name="Telephone" v-slot="{ validate, errors }"
                              tag="div" class="w-100">
            <div class="form-group row">
              <label for="phone" class="col-md-4 col-form-label">Telephone</label>
              <div class="col-md-8 row justify-content-between mx-0">
                <input :class="{'is-invalid':!!errors[0]}" type="text" id="phone" v-model="account.phone" class="form-control " name="phone"
                       minlength="9" maxlength="9"
                       required/>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider :rules="{required: true}" vid="city" name="Ville" v-slot="{ validate, errors }"
                              tag="div" class="w-100">
            <div class="form-group row">
              <label for="city" class="col-md-4 col-form-label">Ville</label>
              <div class="col-md-8">
                <input :class="{'is-invalid':!!errors[0]}" type="text" id="city" v-model="account.city" class="form-control" name="city" required/>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
        <div class="col-md-3 d-flex flex-column align-items-center">
          <div @click="$refs.avatarInput.click()"
               class="cursor-pointer wh72x3 d-flex justify-content-center align-items-center bg-gray-100 position-relative">
            <span class="fa fa-plus text-secondary fz-80" v-if="!account.avatar"></span>
            <template v-else>
              <img :src="account.avatar" class="img-fluid" alt="">
              <div class="bg-white position-absolute w_94 bottom-1 text-center opacity-7">
                <span class="fa fa-pen text-dark fz-20 my-2"></span>
              </div>
              <!--                  <span class="fa fa-pen text-white fz-50 position-absolute"></span>-->
            </template>
          </div>

          <input type="file" id="file" ref="avatarInput" accept="image/*" @change="fileChange" class="d-none">

          <button @click="submitAvatar" class="btn bg-gray-100 w_100 py-1 px8 title fz-14 mt-4"
                  :disabled="haveImage">Modifier la photo de profil
          </button>
          <button @click="$refs.modal.show()" class="btn bg-gray-100 w_100 mb-3 py-1 px8 title fz-14 mt-2"
                  :disabled="!isFormValid">
            Modifier le mot de passe
          </button>
          <button @click="submitData" class="btn bg-green text-white w_100 py-1 px8 title fz-20 mb-3 mt-auto"
                  :disabled="!isFormValid">
            Valider
          </button>
        </div>
      </div>
    </ValidationObserver>
    <b-modal id="password-modal" modal-class="content-only modal-large" size="lg"
             :no-close-on-backdrop="loader" hide-footer
             content-class="password-modal" ref="modal" centered>
      <template v-slot:modal-title>
        <h3 class="title">Modifier le mot de passe</h3>
      </template>
      <div class="password-form">
        <div class="top">
          <p class="description">
            Veuillez remplir les champs
          </p>
          <!--          <button class="close btn btn-gray btn-square" @click="showModal = false"><i class="ti-close"></i></button>-->
        </div>
        <ValidationObserver ref="avatarForm">
          <div class="content mt-2">
            <div class="form mt-4">
              <ValidationProvider vid="oldpassword" rules="required" name="Ancien mot de passe" v-slot="{ errors }">
                <div class="form-group">
                  <label for="oldpassword">Ancien mot de passe</label>
                  <input id="oldpassword" :class="{'is-invalid':!!errors[0]}" type="password" name="oldpassword"
                         v-model="account.oldpassword"
                         class="form-control">
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              <ValidationProvider vid="password" rules="required" name="Nouveau mot de passe" v-slot="{ errors }"
                                  ref="password">
                <div class="form-group">
                  <label for="password">Nouveau mot de passe</label>
                  <input id="password" :class="{'is-invalid':!!errors[0]}" type="password" name="password"
                         v-model="account.password"
                         class="form-control">
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              <ValidationProvider vid="newpassword" :rules="{required: true, confirmed: 'password'}"
                                  name="Confirmation de mot de passe" v-slot="{ errors }">
                <div class="form-group">
                  <label for="newpassword">Confirmer le mot de passe</label>
                  <input id="newpassword" :class="{'is-invalid':!!errors[0]}" type="password" name="newpassword"
                         v-model="account.newpassword"
                         class="form-control">
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </ValidationObserver>
        <div class="bottom row mx-0">
          <button @click="$refs.modal.hide()" class="btn px-4 btn-secondary mr-auto">Annuler</button>
          <button @click="updatePassword" class="btn px-4 btn-outline-green ml-auto">Modifier</button>
        </div>
      </div>
    </b-modal>
    <div class="loader absolute" v-if="loader"></div>
  </div>
</template>
<script>
import moment from 'moment';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css'
import {mapGetters} from 'vuex';
import axios from "axios";
import store from "@/store/store";


export default {
  components: {
    flatPickr,
  },
  props: {
    backRoute: {type: [String, Object, null], default: null}
  },
  filters: {
    ago: function (data) {
      return moment(data).fromNow();
    }
  },
  data() {
    return {
      loader: false,
      account: {
        id: null,
        oldpassword: null,
        password: null,
        newpassword: null,
        school_name: null,
        first_name: null,
        last_name: null,
        pseudo: null,
        classroom_id: null,
        description: null,
        birth_date: null,
        gender: null,
        email: null,
        phone: null,
        city: null,
        avatar: null,
        image: null,
        phone_suffix: null,
        phone_number: null,
      },
      classrooms: [],
      school: null,
      configDate: {
        time_24hr: true,
        enableTime: false,
        dateFormat: 'Y-m-d',
        // defaultDate: null,
      },
    }
  },
  methods: {
    moment,
    submitAvatar() {
      const data = new FormData();
      if (this.account.image && this.account.image.file) {
        this.loader = true;
        data.append('avatar', this.account.image.file)
        axios.post('/profile/avatar', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(({data}) => {
          this.account.avatar = data.avatar;
          this.account.image = null;
          this.loadUser();
        }).catch((error) => {
          console.error(error)
        }).finally(() => {
          this.loader = false;
        })
      }
    },
    fileChange(event) {
      const file = event.target.files[0]
      this.account.image = {
        name: file.name,
        path: URL.createObjectURL(file),
        file: file
      };
      if (this.account.image) {
        this.account.avatar = this.account.image.path;
      }
    },
    loadUser() {
      this.loader = true;
      axios.get('/home').then(({data}) => {
        store.commit('set_data', data)
      }).finally(() => {
        this.loader = false;
      });
    },
    loadData() {
      this.loader = true;
      axios.get('profile')
        .then(({data}) => {
          this.initValues(data)
        })
        .catch((error) => {
          console.error(error)
        }).finally(() => {
        this.loader = false;
      });
    },
    initValues(data = null) {
      ['id', 'first_name', 'last_name', 'school_name', 'pseudo', 'description', 'classroom_id', 'birth_date', 'gender', 'email', 'password', 'phone', 'city', 'avatar', 'notification'].forEach(key => {
        this.account[key] = data.user[key];
      })
      this.school = data.school
      this.classrooms = data.classrooms
    },
    isFormValid() {
      return this.account.first_name.length >= 4 && this.account.description.length < 4
        && this.account.last_name >= 4;
    },
    submitData() {
      this.$refs.form.validate().then(result => {
        if (result) {
          this.loader = true;
          axios.post('/profile', {
            id: this.account.id,
            first_name: this.account.first_name,
            last_name: this.account.last_name,
            school_name: this.account.school_name,
            pseudo: this.account.pseudo,
            description: this.account.description,
            classroom_id: this.account.classroom_id,
            birth_date: this.account.birth_date,
            gender: this.account.gender,
            city: this.account.city,
            phone: this.account.phone,
            email: this.account.email,
            avatar: this.account.avatar,
            notification: this.account.notification,
          })
            .then(() => {
              this.loadUser();
            })
            .catch((error) => {
              console.log(error)
              // if (err.response.status === 422) {
              //   this.displayServerError(err.response.data)
              // }
            }).finally(() => {
            this.loader = false;
          })
        }
      })
    },
    updatePassword() {
      this.$refs.avatarForm.validate().then(result => {
        if (result) {
          this.loader = true;
          axios.post('/profile/password', {
            oldpassword: this.account.oldpassword,
            newpassword: this.account.newpassword,
          }).then(() => {
            this.$refs.modal.hide();
            this.account.oldpassword = null;
            this.account.password = null;
            this.account.newpassword = null;
          }).catch((error) => {
            console.log(error)
            // if (err.response.status === 422) {
            //   this.displayServerError(err.response.data)
            // }
          }).finally(() => {
            this.loader = false;
          })
        }
      })
    }
  },
  computed: {
    haveImage() {
      return this.account.image === null;
    },
  },
  beforeMount() {
    this.loadData();
    this.$route.meta.backToRoute = this.backRoute ? this.backRoute : this.$router.resolve({name: 'home'});
    this.$route.meta.other_header_menu = true;
  }
}
</script>
<style>
</style>
